import { fetchSessionId, getSavedDeviceUuid, getSavedUsername, saveDeviceUuid, saveUsername, saveSessionId } from '../utils/Prefs'
import * as SessionActions from '../actions/SessionActions'
import { handleLogout } from '../utils/SessionUtils'

// Centralized API URLs
const PROD_API_URL = "https://api.esatsang.live/wapi/"
const LOCAL_API_URL = "http://localhost:3001/wapi/"

// Development Configuration
// Set DEV_BASE_URL to "/wapi/" to use the proxy defined in setupProxy.js (Recommended to avoid CORS)
// Set DEV_BASE_URL to LOCAL_API_URL to hit local server directly (Requires CORS enabled on local server)
const DEV_BASE_URL = "/wapi/" 
// const DEV_BASE_URL = LOCAL_API_URL

const BASE_URL = process.env.NODE_ENV === 'development' ? DEV_BASE_URL : PROD_API_URL

export const fetchEntitlements = (dispatch) => {
    const sessionId = fetchSessionId()
    const uuid = getSavedDeviceUuid()
    const uid = getSavedUsername()
    let url = BASE_URL + 'v2/getUserEntitlements';
    let request = new Request(url, {
        method: 'GET',
        headers: {
            SESSION_TOKEN: sessionId,
            UUID: uuid,
            UID: uid
        }
    })
    return fetch(request)
        .then(response => validateSession(response, dispatch))
        .then(handleErrors)
        .then(response => response.json())
}

export const fetchMasterPlayList = (playbackUrl) => {
    const isDev = process.env.NODE_ENV === 'development';
    let url = playbackUrl;
    if (isDev && playbackUrl.startsWith('https://dist.esatsang.live')) {
        url = playbackUrl.replace('https://dist.esatsang.live', '/live-stream');
    }
    let request = new Request(url, {
        method: 'GET',
    })
    return fetch(request)
        .then(response => {
            return response.ok
        })
}

export const loginUser = (username, password, uuid, dispatch) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "UUID": uuid,
        },
        body: JSON.stringify({ username, password, "mode": 'web' })
    };
    let url = BASE_URL + 'loginUser';
    return fetch(url, requestOptions)
        .then(response => validateSession(response, dispatch))
        .then(response => handleErrors(response))
        .then(response => response.json())
        .then(data => {
            saveDeviceUuid(uuid)
            saveUsername(username)
            saveSessionId(data.sessionToken)
            dispatch(SessionActions.getLoggedInAction({ sessionId: data.sessionToken, userId: username, uuid }))
            return true
        })
}

export const checkIfTransmissionStarted = (dispatch) => {
    const sessionId = fetchSessionId()
    const uuid = getSavedDeviceUuid()
    const uid = getSavedUsername()
    let url = BASE_URL + 'transmission-status';
    let request = new Request(url, {
        method: 'GET',
        headers: {
            SESSION_TOKEN: sessionId,
            UUID: uuid,
            UID: uid
        }
    })
    return fetch(request)
        .then(response => validateSession(response, dispatch))
        .then(handleErrors)
        .then(response => response.json())
        .then(data => {
            if (data == null || typeof data !== 'object') return false
            return data.status === true
        })
}

export const recordUserAttendance = (eventID, entitlementName, dispatch) => {
    const sessionId = fetchSessionId()
    const uuid = getSavedDeviceUuid()
    const uid = getSavedUsername()
    let url = BASE_URL + 'recordUserAttendance';
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            SESSION_TOKEN: sessionId,
            UUID: uuid,
            UID: uid
        },
        body: JSON.stringify({ eventID, entitlementName })
    }
    return fetch(url, requestOptions)
        .then(response => validateSession(response, dispatch))
        .then(response => handleErrors(response))
        .then(response => response.json())
}

export const recordHeartbeat = (eventID, entitlementName, dispatch) => {
    const sessionId = fetchSessionId()
    const uuid = getSavedDeviceUuid()
    const uid = getSavedUsername()
    let url = BASE_URL + 'heartbeat';
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            SESSION_TOKEN: sessionId,
            UUID: uuid,
            UID: uid
        },
        body: JSON.stringify({ eventID, entitlementName })
    }
    return fetch(url, requestOptions)
        .then(response => validateSession(response, dispatch))
        .then(response => handleErrors(response))
        .then(response => response.json())
}

/**
 * Subscribe an FCM token to push notifications.
 * Topic assignment is handled server-side — the frontend doesn't need to know about topics.
 */
export const pnSubscribe = (token) => {
    const sessionId = fetchSessionId()
    const uuid = getSavedDeviceUuid()
    const uid = getSavedUsername()
    const url = BASE_URL + 'pn/subscribe'
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            SESSION_TOKEN: sessionId,
            UUID: uuid,
            UID: uid
        },
        body: JSON.stringify({ token })
    })
}

/**
 * Unsubscribe an FCM token from push notifications.
 * Topic assignment is handled server-side — the frontend doesn't need to know about topics.
 */
export const pnUnsubscribe = (token) => {
    const sessionId = fetchSessionId()
    const uuid = getSavedDeviceUuid()
    const uid = getSavedUsername()
    const url = BASE_URL + 'pn/unsubscribe'
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            SESSION_TOKEN: sessionId,
            UUID: uuid,
            UID: uid
        },
        body: JSON.stringify({ token })
    })
}

export const checkEntitlementStatus = (name,dispatch) => {
    const sessionId = fetchSessionId()
    const uuid = getSavedDeviceUuid()
    const uid = getSavedUsername()
    let url = BASE_URL + 'entitlement?entitlement_name='+name;
    let request = new Request(url, {
        method: 'GET',
        headers: {
            SESSION_TOKEN: sessionId,
            UUID: uuid,
            UID: uid
        }
    })
    return fetch(request)
        .then(response => validateSession(response, dispatch))
        .then(handleErrors)
        .then(response => response.json())
}

function validateSession(response, dispatch) {
    if (!response.ok) {
        if (401 === response.status) {
            handleLogout(dispatch)
        }
    }
    return response
}

function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}
